import React from "react";
import {
  PronosticV2,
  isInputLikeElement,
  // PronosticV2Results,
} from "pronosticsv2/types/pronosticv2.model";
import { isValidUrl } from "./PlayPronosticV2Form";
import { renderWithLineBreaks } from "common/utils/renderWithLineBreaks";

interface PronosticResultDisplayProps {
  pronosticV2: PronosticV2;
  pronosticIndex: number;
  header: string;
  predictions?: {
    index: number;
    values?: Array<string | number>;
  };

  titleSize: string;
  titleColor: string;
}

export const PronosticPredictionsDisplay: React.FC<
  PronosticResultDisplayProps
> = ({
  pronosticV2,
  pronosticIndex,
  header,
  predictions,

  titleSize,
  titleColor,
}) => {
  //console.log("predictions data:", predictions);

  const displayPronosticIndex = pronosticIndex - 1;
  const pronostic =
    pronosticV2.commonSettings.general.moduleSettings.pronostics[
      displayPronosticIndex
    ];

  if (!pronostic) {
    return null; // Handle case where pronostic element is missing
  }

  // console.log("pronostic element:", pronostic);

  // Safely destructure with defaults
  const [value1 = null, value2 = null] = predictions?.values || [];

  // Handle empty predictions case
  if (!predictions || !predictions.values || predictions.values.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center mt-8">
        <div className="flex flex-col gap-4 items-center w-full">
          <div className="w-full">
            <h1
              className="text-left"
              style={{ color: titleColor, fontSize: titleSize }}
            >
              {header}
            </h1>
          </div>
          <div className="text-center text-lg">Loading...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center mt-8 ">
      {/* Title and content grouped closely */}
      <div className="flex flex-col gap-4 items-center w-full">
        <div className="w-full ml-12">
          <h1
            className="text-left"
            style={{ color: titleColor, fontSize: titleSize }}
          >
            {header}
          </h1>
        </div>

        <div className="flex items-center justify-center gap-4">
          {isInputLikeElement(pronostic) ? (
            <>
              {/* Left visual + label aligned to bottom */}
              <div className="flex flex-col w-[100px] mt-auto items-center">
                {isValidUrl(pronostic.element2Visual) &&
                  pronostic.element2Visual && (
                    <img
                      src={pronostic.element2Visual}
                      alt=""
                      style={{
                        width: "120px",
                        height: "120px",
                        objectFit: "contain",
                        zIndex: 0,
                      }}
                      className="ml-9"
                    />
                  )}
                <span className="text-center">
                  {renderWithLineBreaks(pronostic.element3Title) ?? ""}
                </span>
              </div>

              {/* First value - centered vertically */}
              <div className="text-center text-6xl w-[70px]">{value1}</div>
              {value2 !== null && value2 !== undefined ? (
                <div className="text-center text-6xl -mx-3">-</div>
              ) : null}

              {/* Second value - optional, centered vertically */}
              {value2 !== null && value2 !== undefined ? (
                <div className="text-center text-6xl w-[70px]">{value2}</div>
              ) : null}

              {/* Right visual + label aligned to bottom */}
              <div className="flex flex-col w-[100px] mt-auto items-center">
                {isValidUrl(pronostic.element7Visual) &&
                pronostic.element7Visual ? (
                  <img
                    src={pronostic.element7Visual}
                    alt=""
                    style={{
                      width: "120px",
                      height: "120px",
                      objectFit: "contain",
                      zIndex: 0,
                    }}
                    className="mr-9"
                  />
                ) : null}
                <span className="text-center">
                  {renderWithLineBreaks(pronostic.element6Title) ?? ""}
                </span>
              </div>
            </>
          ) : (
            <div className="text-center text-5xl">
              <p>{predictions.values}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
